import React from "react";
import { QuoteIcon, StarIcon } from "lucide-react";
import { TESTIMONIALS } from "../lib/data";
export function Testimonials() {
  return <section className="px-4 py-6" data-id="element-192" data-mp="3kr5uq9dydbmc">
      <h2 className="mb-4 text-center text-xl font-black text-white" data-id="element-193" data-mp="3fze3dwmz31v5">
        Profes de todo el país ya lo están usando
      </h2>
      <div className="space-y-3" data-id="element-194" data-mp="3azjd9vb0ugb5">
        {TESTIMONIALS.map(t => <article key={t.name} className="rounded-xl border border-white/10 bg-white/95 p-4 shadow-md" data-id="element-195" data-mp="36ypqj59bf7ju">
            <QuoteIcon className="h-5 w-5 text-[#8bc34a]" data-id="element-196" data-mp="31z37ugapwz3n" />
            <p className="mt-1 text-sm leading-snug text-slate-700" data-id="element-197" data-mp="2x0jqyuazedi5">{t.text}</p>
            <div className="mt-3 flex items-center gap-3" data-id="element-198" data-mp="2s1q8engu7wb4">
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#0f2c4a] text-sm font-bold text-white" data-id="element-199" data-mp="2s39puhe8cdeh">
                {t.name.charAt(0)}
              </div>
              <div className="min-w-0" data-id="element-200" data-mp="qbevbek3upjh">
                <p className="text-sm font-bold text-[#0f2c4a]" data-id="element-201" data-mp="q891jm0j6zhf">
                  {t.name}, {t.age}
                </p>
                <p className="truncate text-xs text-slate-500" data-id="element-202" data-mp="m51a7p5h516u">
                  {t.role} · {t.location}
                </p>
              </div>
              <div className="ml-auto flex gap-0.5" data-id="element-203" data-mp="7926eqpedn7i">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" data-id="element-204" data-mp="c73r1g2h1ul3" data-mpi={i} />)}
              </div>
            </div>
          </article>)}
      </div>
    </section>;
}